import { useContext } from "react";

import { CorrectOrIncorrect, QuestionId } from "@common";
import { WebsocketContext } from "../contexts/websocketContext";
import { StatValues } from "../interfaces/answerStats.interface";
import { QuizSlideDataSequence } from "../interfaces/question.interface";
import useQuizSlideInfo from "./useQuizSlideInfo";

const useSocket = () => {
  const { socket, isMultiplayerHost, inMultiplayerSession } = useContext(WebsocketContext);
  const { amountSlidesUncompleted } = useQuizSlideInfo();

  const wsHostRoom = () => {
    socket.emit("hostRoom");
  };

  const wsLeaveRoom = () => {
    socket.emit("leaveRoom");
  };

  const wsSetQuiz = (quizSlideDataSequence: QuizSlideDataSequence) => {
    socket.emit("setQuiz", quizSlideDataSequence);
  };

  const wsStartGame = () => {
    socket.emit("startGame");
  };

  const wsJoinRoom = (inputCode: string) => {
    socket.emit("joinRoom", inputCode);
  };

  const wsUpdateClientData = (inputName: string | undefined, id: string) => {
    if (inputName !== undefined) {
      socket.emit("requestUpdateClientData", inputName);
    }
  };

  const wsQuestionCompleted = () => {
    if (isMultiplayerHost && inMultiplayerSession) {
      if (amountSlidesUncompleted <= 1) wsQuizOver();
      else socket.emit("nextQuestion");
    }
  };

  const wsToggleBanPlayer = (playerId: string, isBanned: boolean) => {
    socket.emit("toggleBanPlayer", playerId, isBanned);
  };

  const wsQuizOver = () => {
    socket.emit("quizOver");
  };

  const wsAnswerQuestion = (
    questionId: QuestionId,
    correctOrIncorrect: CorrectOrIncorrect,
    answerValues: StatValues,
    isQuestion: boolean
  ) => {
    socket.emit("answerQuestion", questionId, correctOrIncorrect, answerValues, isQuestion);
  };

  const wsRestartGame = () => {
    socket.emit("restartGame");
  };

  const wsEndGame = () => {
    socket.emit("endGame");
  };

  const wsSendComment = (text: string) => {
    socket.emit("sendComment", text);
  };

  const wsReadyForNextQuestion = (questionId: QuestionId) => {
    socket.emit("readyForNextQuestion", questionId);
  };

  return {
    socket,
    wsHostRoom,
    wsLeaveRoom,
    wsSetQuiz,
    wsStartGame,
    wsJoinRoom,
    wsUpdateClientData,
    wsQuestionCompleted,
    wsQuizOver,
    wsAnswerQuestion,
    wsRestartGame,
    wsEndGame,
    wsReadyForNextQuestion,
    wsSendComment,
    wsToggleBanPlayer,
  };
};

export default useSocket;
